<template>
  <LightBox
    ref="lightbox"
    :show-caption="true"
    :show-thumbs="false"
    :show-light-box="false"
    :media="lightboxMedia"
    @onImageChanged="onImageChanged"
  >
    <template v-slot:customCaption>
      <div v-if="hasCaption" class="caption-lightbox">
        <p v-if="captionTitle" class="line">{{ captionTitle }}</p>
        <p v-if="captionSource" class="line">
          {{ $t("media.source") }}: {{ captionSource }}
        </p>
      </div>
    </template>
  </LightBox>
</template>

<script>
import LightBox from "vue-image-lightbox";

export default {
  name: "MediaLightBox",
  components: {
    LightBox
  },
  data: function() {
    return {
      currentIndex: 0,
      mediaItems: []
    };
  },
  computed: {
    images() {
      return this.mediaItems.filter(m => m.type === "image");
    },
    lightboxMedia() {
      return this.images.map(this.convertMediaItem);
    },
    currentImage() {
      return this.images[this.currentIndex];
    },
    hasCaption() {
      return this.currentImage.title || this.currentImage.source;
    },
    captionTitle() {
      return this.currentImage.title;
    },
    captionSource() {
      return this.currentImage.source;
    }
  },
  beforeCreate() {
    this.$root.$on("lightboxSetMediaItems", m => this.setMediaItems(m));
    this.$root.$on("lightboxShowMediaItem", m => this.showMediaItem(m));
  },
  beforeDestroy() {
    this.$root.$off("lightboxSetMediaItems");
    this.$root.$off("lightboxShowMediaItem");
  },
  methods: {
    setMediaItems(mediaItems) {
      this.mediaItems = mediaItems;
    },
    showMediaItem(id) {
      this.currentIndex = this.images.findIndex(m => m.id == id);

      this.$refs.lightbox.showImage(this.currentIndex);
    },
    onImageChanged(index) {
      this.currentIndex = index;
    },
    convertMediaItem(mediaItem) {
      return {
        src: mediaItem.image_url
      };
    }
  }
};
</script>

<style lang="scss">
.vue-lb-container {
  .vue-lb-content {
    margin: auto 0;
  }
  .vue-lb-modal-image {
    max-height: 75vh;
  }
}

.caption-lightbox {
  margin-top: 30px;
  text-align: center;

  .line {
    margin-bottom: 0;
    line-height: 2rem;
  }
}
</style>
